import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { CartService } from 'src/app/components/shared/services/cart.service';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductDialogComponent } from '../../products/product-dialog/product-dialog.component';
import { ConfigService } from 'src/app/components/shared/services/config.service';
import { CompanyService } from 'src/app/components/shared/services/company.service';
import { SwiperConfig } from '../../../shared/directive/swiper.directive';

@Component({
    selector: 'app-product-carousel-three',
    templateUrl: './product-carousel-three.component.html',
    styleUrls: ['./product-carousel-three.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductCarouselThreeComponent implements OnInit {
  contentLoaded = false;
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();

 @Input('product') product: any[] = [];
 public config: SwiperConfig = {};

  constructor(public configService:ConfigService,private cartService: CartService, private productsService: ProductService, private dialog: MatDialog, private router: Router, public companyService:CompanyService) { }
  // @ViewChild(SwiperDirective) directiveRef: SwiperDirective;

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
    }, 3000);
  }
  ngAfterViewInit(){
    this.config = {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      // Swiper 4 breakpoints were max-width, Swiper 12's are min-width: same ranges re-expressed (GX-7106).
      breakpoints: {
        481: { slidesPerView: 2 },
        741: { slidesPerView: 3 },
        961: { slidesPerView: 4 },
        1281: { slidesPerView: 4 }
      }
    }
  }

  // Add to cart
  public addToCart(product: any,  quantity: number = 1) {
    this.cartService.addToCart(product,quantity);
  }

public openProductDialog(product){
  let dialogRef = this.dialog.open(ProductDialogComponent, {
      data: product,
      panelClass: 'product-dialog',
  });
  dialogRef.afterClosed().subscribe(product => {
    if(product){
      this.router.navigate(['/products', product.Id, product.Languages[0].ProductName]);
    }
  });
}
changeProductDetail(ItemID){
  this.router.navigate(['/product', ItemID])
  .then(() => {
    window.location.reload();
  });
}

}
